import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdGptAssistant } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdGptAssistantPayload,
  PostwsGenerativeAiAppGroupIdGptAssistantProps,
} from "./types";
import { isGptAssistantAsyncResult } from "./validators";

export const postwsGenerativeAiAppGroupIdGptAssistant = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdGptAssistant,
  async (
    signal,
    {
      appGroupId,
      copy,
      languageCode,
      lengthType,
      messageType,
      useCampaignData,
      toneType,
      temporaryGuideline,
      brandGuidelineId,
      jobToken,
    }: PostwsGenerativeAiAppGroupIdGptAssistantProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdGptAssistantPayload = {
      job_token: jobToken,
      copy,
      language_code: languageCode,
      length_type: lengthType,
      message_type: messageType,
      use_campaign_data: useCampaignData,
      tone_type: toneType,
      temporary_guideline: temporaryGuideline,
      brand_guideline_id: brandGuidelineId,
    };

    return await fetch(
      `/${appGroupId}/generative_ai/gpt_assistant`,
      "POST",
      payload,
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isGptAssistantAsyncResult
);
